import React from "react";
import AmountWidget from "./AmountWidget";
import Panel from "muicss/lib/react/panel";
import axios from "axios";
import { totalCoins } from "../../common/lumens.js";

export class TotalIssuedPaymon extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = {
      amount: 100000000,
      code: "PMN",
      loading: false,
      public: "GA7SPNYDYDRT5UZGZ6KI7YUBQI67V25CF3C4VHWTM4JPWB6TQDYAJMKV",
    };
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["totalIssuedPaymon"][this.props.lang]}</p>
      </div>
    );
  }
}

export class FounderTeam extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = {
      amount: 5000000,
      code: "PMN",
      loading: false,
      public: "GARZ52FM5HQ4EHKBWPRQPLK6Z37RV5YSAAP7EUMRSONM7VCAOFRUWYCR",
    };
  }

  componentDidMount() {
    fetch(
      `${this.props.horizonURL}/accounts/GARZ52FM5HQ4EHKBWPRQPLK6Z37RV5YSAAP7EUMRSONM7VCAOFRUWYCR`,
      {
        method: "GET",
      },
    )
      .then((response) => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        if (res[0] == 200) {
          this.setState({ amount: res[1]["balances"][0]["balance"] });
        }
      });
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["founderTeamReserve"][this.props.lang]}</p>
      </div>
    );
  }
}

export class NewAnchorReserve extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = {
      amount: 20000000,
      code: "PMN",
      loading: false,
      public: "GC74S4PLJU3G2N2KKB4OHM5N53SQPUGL6VYZLLYMAVTL5QWGNSO3JJIT",
    };
  }

  componentDidMount() {
    fetch(
      `${this.props.horizonURL}/accounts/GC74S4PLJU3G2N2KKB4OHM5N53SQPUGL6VYZLLYMAVTL5QWGNSO3JJIT`,
      {
        method: "GET",
      },
    )
      .then((response) => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        if (res[0] == 200) {
          this.setState({ amount: res[1]["balances"][0]["balance"] });
        }
      });
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["newAnchorReserve"][this.props.lang]}</p>
      </div>
    );
  }
}

export class NewUserReserve extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      code: "PMN",
      loading: false,
      public: "GBWAPGOUIZRXLQHXESZ246VD6MEQHU22BW3IUZ4NMFUJUDTLDJTNEULM",
    };
  }

  componentDidMount() {
    fetch(
      `${this.props.horizonURL}/accounts/GBWAPGOUIZRXLQHXESZ246VD6MEQHU22BW3IUZ4NMFUJUDTLDJTNEULM`,
      {
        method: "GET",
      },
    )
      .then((response) => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        if (res[0] == 200) {
          this.setState({ amount: res[1]["balances"][0]["balance"] });
        }
      });
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["newUserReserve"][this.props.lang]}</p>
      </div>
    );
  }
}

export class MonthlyDistributionReserve extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      code: "PMN",
      loading: false,
      public: "GAN6XE5ZDVFSJQY7CI2YGFIWADVYAE6XIL3BS4N3XM7LPNLHKQ2JXQHB",
    };
  }

  componentDidMount() {
    fetch(
      `${this.props.horizonURL}/accounts/GAN6XE5ZDVFSJQY7CI2YGFIWADVYAE6XIL3BS4N3XM7LPNLHKQ2JXQHB`,
      {
        method: "GET",
      },
    )
      .then((response) => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        if (res[0] == 200) {
          this.setState({ amount: res[1]["balances"][0]["balance"] });
        }
      });
  }

  renderName() {
    return (
      <div>
        <p>
          {this.props.dictionary["monthlyDistributionReserve"][this.props.lang]}
        </p>
      </div>
    );
  }
}

export class RefundPmn extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      code: "PMN",
      loading: false,
      public: "GBZGSP4PT43DVEPO47VXDJMQEI3HZX5A42YMOBV6JHP43T5C6KLAHRQA",
    };
  }

  componentDidMount() {
    fetch(
      `${this.props.horizonURL}/accounts/GBZGSP4PT43DVEPO47VXDJMQEI3HZX5A42YMOBV6JHP43T5C6KLAHRQA`,
      {
        method: "GET",
      },
    )
      .then((response) => {
        const statusCode = response.status;
        const data = response.json();
        return Promise.all([statusCode, data]);
      })
      .then((res) => {
        if (res[0] == 200) {
          this.setState({ amount: res[1]["balances"][0]["balance"] });
        }
      });
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["refundPmn"][this.props.lang]}</p>
      </div>
    );
  }
}

export class TotalDistributedPmn extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = { amount: 20000000, code: "PMN", loading: false };
  }

  renderName() {
    return (
      <div>
        <p>
          {this.props.dictionary["totalDistributedPaymon"][this.props.lang]}
        </p>
      </div>
    );
  }
}

export class FounderTeamDistributed extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = { amount: 0, code: "PMN", loading: false };
  }

  renderName() {
    return (
      <div>
        <p>
          {this.props.dictionary["founderTeamDistributed"][this.props.lang]}
        </p>
      </div>
    );
  }
}

export class NewAnchorDistributed extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = { amount: 20000000, code: "PMN", loading: false };
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["newAnchorDistributed"][this.props.lang]}</p>
      </div>
    );
  }
}

export class NewUserDistributed extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = { amount: 0, code: "PMN", loading: false };
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["newUserDistributed"][this.props.lang]}</p>
      </div>
    );
  }
}

export class MonthlyDistributed extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = { amount: 0, code: "PMN", loading: false };
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["monthlyDistributed"][this.props.lang]}</p>
      </div>
    );
  }
}

export class TotalGold extends AmountWidget {
  constructor(props) {
    super(props);
    this.state = { amount: 20, code: "kg", loading: false };
  }

  renderName() {
    return (
      <div>
        <p>{this.props.dictionary["totalGold"][this.props.lang]}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/components/DistributionWidgets.js